var _effectorFileName = "/src/widgets/layouts/main/components/sidebar/sidebar.tsx";
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import HamburgerIcon from '@/shared/components/icons/hamburger-icon';
import { ThemeToggle } from '@/shared/components/theme-toggle';
import { Button } from '@/shared/components/ui/button';
import { Separator } from '@/shared/components/ui/separator';
import { Sheet, SheetClose, SheetContent, SheetTrigger } from '@/shared/components/ui/sheet';
import { cn } from '@/shared/lib/cn';
export const Sidebar = () => {
  const pathname = usePathname();
  return <Sheet>
      <SheetTrigger asChild>
        <Button variant="secondary" size="icon-lg" aria-label="Open sidebar">
          <HamburgerIcon />
        </Button>
      </SheetTrigger>

      <SheetContent className="flex flex-col justify-between pl-8">
        <nav className="flex flex-col place-items-start py-10">
          <div className="flex w-full flex-col space-y-3">
            <SheetClose asChild>
              <Link className={cn({
              'text-brand-accent-normal': pathname === '/'
            })} href="/" aria-label="Go to main page">
                Main page
              </Link>
            </SheetClose>

            <Separator className="mb-4 mt-2 w-full" />
          </div>
        </nav>

        <div>
          <Separator className="mb-4 mt-2 w-full" />
          <ThemeToggle />
        </div>
      </SheetContent>
    </Sheet>;
};